export default {
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/sales/option-support", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/sales/option-support/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/sales/option-support/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
